import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    nombreAsegurado : "",
    codigoBanco     : "",
    tipoCuenta      : "",
    monedaCuenta    : "",
    numeroCuenta    : "",
    aceptoTerminos  : false,
    nombreDocCCI    : "",
    archivoDocCCI   : "",
    tipEndoso      : ""
};

export const refundInformationSlice = createSlice({
    name : "refundInformation",
    initialState,
    reducers:{
        addRefundInformation : (state, action) => {
            const { nombreAsegurado, codigoBanco, tipoCuenta, monedaCuenta, numeroCuenta, nombreDocCCI, archivoDocCCI } = action.payload;
            state.nombreAsegurado = nombreAsegurado;
            state.codigoBanco = codigoBanco;
            state.tipoCuenta = tipoCuenta;
            state.monedaCuenta = monedaCuenta;
            state.numeroCuenta = numeroCuenta;
            state.nombreDocCCI = nombreDocCCI;
            state.archivoDocCCI = archivoDocCCI;
        },
        aceptTerms : (state, action) => {
            state.aceptoTerminos = action.payload;
        },
        addTipoEndoso : (state, action) => {
            state.tipEndoso = action.payload;
        }
    }
});

export const { addRefundInformation, aceptTerms, addTipoEndoso } = refundInformationSlice.actions;
export default refundInformationSlice.reducer;